import React from "react";
import { comparisonRows } from "../data/product";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function Comparison() {
  return <section className="bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-71" data-mp="1g68axe1oo2cd">
      <SectionHeading title={<>
            Comprati, o <Accent data-id="element-73" data-mp="1pynqk4piceu3">fatti da te</Accent>
          </>} subtitle="Stesso scaffale, due barattoli molto diversi." data-id="element-72" data-mp="1l6m5pue9xfsg" />
      <div className="mx-auto mt-8 max-w-2xl overflow-hidden rounded-[28px] border border-line bg-cream shadow-[0_18px_40px_-28px_rgba(86,18,54,0.5)]" data-id="element-74" data-mp="1uwfg4s2ojov4">
        <table className="w-full table-fixed border-collapse text-center" data-id="element-75" data-mp="23xvqx0xepszv">
          <thead data-id="element-76" data-mp="23vsr5p6gclhy">
            <tr data-id="element-77" data-mp="28wzzbpcibmp5">
              <th scope="col" className="border-r border-line px-3 py-4 font-serif text-2xl font-semibold text-rose/60 sm:text-[28px]" data-id="element-78" data-mp="28xi6hh0pjlbu">
                Comprati
              </th>
              <th scope="col" className="px-3 py-4 font-serif text-2xl font-semibold text-rose sm:text-[28px]" data-id="element-79" data-mp="eiz4rgnzpluv">
                Fatti da te
              </th>
            </tr>
          </thead>
          <tbody data-id="element-80" data-mp="1m2k0y0fcnrod">
            {comparisonRows.map(r => <tr key={r.made} className="border-t border-line" data-id="element-81" data-mp="1h8fq362yqzi0">
                <td className="border-r border-line px-3 py-4 text-[14px] leading-snug text-muted sm:px-6 sm:text-base" data-id="element-82" data-mp="1d7vu45u4m1xg">
                  {r.bought}
                </td>
                <td className="px-3 py-4 text-[14px] font-semibold leading-snug text-wine sm:px-6 sm:text-base" data-id="element-83" data-mp="187hmgowfstzy">
                  {r.made}
                </td>
              </tr>)}
            <tr className="border-t border-line" data-id="element-84" data-mp="20w5autchfzhq">
              <td className="border-r border-line px-3 py-4 text-[14px] italic text-muted sm:text-base" data-id="element-85" data-mp="1vxu1sku0ht0k">“Da dove viene?”</td>
              <td className="px-3 py-4 text-[14px] font-semibold italic text-rose sm:text-base" data-id="element-86" data-mp="1qzk4a3ktegbs">“L'ho fatto io.”</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}